import { required, optional } from 'AppReact/schema';

export const filterDropdownOption = {
  id: required(['string', 'integer']),
  displayName: required('string'),
  image: optional('string'),
  icon: optional('object'),
}
